/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { getDateFormat } from "@utils/datePickerUtils";
import { Dialog, Button, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import PulseLoader from "react-spinners/PulseLoader";
import UserInfo from "@utils/UserInfo";
import PostComment from "../PostComment/PostComment";
import closeIcon from "@icons/ic-close-white.svg";
import {
  HeaderWrapper,
  Title,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  CommentContainerFirst,
  CommentContainerSecond,
  AuthorInfo,
  DateInfo,
  ButtonWrapper,
} from "./DiscussionList.styled";
import "./DiscussionList.scss";
import communicationIcon from "@icons/ic-communication.svg";

const DiscussionList = (props) => {
  const { t, entityType, entityId, onClose } = props;

  const [mentionList, setMentionList] = useState([]);
  const [descriptionData, setDescriptionData] = useState("");

  const [loading, setLoading] = useState(false);
  const [isCommentCreating, setIsCommentCreating] = useState(false);
  const [commentData, setCommentData] = useState([]);

  const [createCommentAPIError, setCreateCommentAPIError] = useState("");

  const fetchComments = () => {
    setLoading(true);
    axios
      .get(`/general/discussions?entityId=${entityId}&entityType=${entityType}`)
      .then((response) => {
        setCommentData(response?.data?.discussionThread[0]);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        handleApiError(error);
      });
  };

  useEffect(() => {
    fetchComments();
  }, []);

  const validateForm = (data) => {
    let isFormValid = true;
    if (!data) {
      isFormValid = false;
    }
    return isFormValid;
  };

  const getFormData = () => {
    let adminMentionsList = [];
    let groupMentionsList = [];
    adminMentionsList = mentionList
      .map((mention) => {
        if (mention.type === "admin") {
          const tempData = { id: mention.userId };
          return tempData;
        }
      })
      .filter((notUndefined) => notUndefined !== undefined);

    groupMentionsList = mentionList
      .map((mention) => {
        if (mention.type === "group") {
          const tempData = { id: mention.userId };
          return tempData;
        }
      })
      .filter((notUndefined) => notUndefined !== undefined);

    // Get author ID from localStorage (JWT auth)
    const authorId = UserInfo.getUser().id;

    const data = {
      threadId: commentData?.threadId ?? "",
      entityId,
      entityType,
      author: {
        id: authorId,
      },
      comment: descriptionData,
      mentions: {
        adminMentions: adminMentionsList,
        groupMention: groupMentionsList,
      },
    };

    return data;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(descriptionData);
    if (isFormValid) {
      const data = getFormData();
      setIsCommentCreating(true);
      setCreateCommentAPIError("");
      axios
        .post(`/general/discussions`, data)
        .then(() => {
          setIsCommentCreating(false);
          setDescriptionData("");
          setMentionList([]);
          fetchComments();
        })
        .catch((error) => {
          setIsCommentCreating(false);
          setMentionList([]);
          setCreateCommentAPIError(error.response?.data?.message ?? "");
        });
    }
  };

  return (
    <div className="dialogParent">
      <Dialog className="dialog-style">
        <div>
          <HeaderWrapper>
            <Button
              onClick={onClose}
              styles={{
                backgroundColor: "transparent",
                border: "none",
                height: "auto",
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Image
                src={closeIcon}
                alt="close meeting report popup"
                styles={{ width: "auto" }}
              />
            </Button>
            <Title>
              {t("DISCUSSION_THREAD")}
              <Image
                src={communicationIcon}
                alt={t("COMMUNICATION")}
                title={t("COMMUNICATION")}
                styles={{ width: "auto", height: "39px", marginTop: "-8px" }}
              />
            </Title>
          </HeaderWrapper>
          <FormBody>
            <OptionsWrapper>
              <FlexRow>
                <SectionContainer>
                  <div>
                    {loading && <PulseLoader size={15} color="#1bace4" />}
                    {commentData?.comments?.length !== "" &&
                      commentData?.comments?.map((data, index) => {
                        return (
                          <GridRow column="1fr" key={"discussion-" + data.id}>
                            {index % 2 === 0 && (
                              <div>
                                <AuthorInfo textPosition="initial">
                                  {data.author.firstName +
                                    " " +
                                    data.author.lastName}
                                  {" - "}
                                  <DateInfo>
                                    {data.createdAt
                                      ? getDateFormat(data.createdAt, "YYYY-MM-DD HH:mm", "HH:mm")
                                      : ""}
                                  </DateInfo>
                                </AuthorInfo>
                                <CommentContainerFirst className="commentFirst">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: data.comment,
                                    }}
                                  ></div>
                                </CommentContainerFirst>
                              </div>
                            )}
                            {index % 2 !== 0 && (
                              <div>
                                <AuthorInfo textPosition="end">
                                  {data.author.firstName +
                                    " " +
                                    data.author.lastName}
                                  {" - "}
                                  <DateInfo>
                                    {data.createdAt
                                      ? getDateFormat(data.createdAt, "YYYY-MM-DD HH:mm", "HH:mm")
                                      : ""}
                                  </DateInfo>
                                </AuthorInfo>
                                <CommentContainerSecond className="commentSecond">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: data.comment,
                                    }}
                                  ></div>
                                </CommentContainerSecond>
                              </div>
                            )}
                          </GridRow>
                        );
                      })}
                    <GridRow>
                      <PostComment
                        setMentionList={setMentionList}
                        setDescriptionData={setDescriptionData}
                        descriptionData={descriptionData}
                      />
                    </GridRow>
                  </div>
                </SectionContainer>
              </FlexRow>
            </OptionsWrapper>
          </FormBody>
          <ButtonWrapper>
            {createCommentAPIError && <div>{createCommentAPIError}</div>}
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                border: "1px solid #ccc",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onClose}
            >
              {t("CLOSE")}
            </Button>
            <Button
              styles={{
                color: "white",
                background: "#1BACE4",
                border: "1px solid #1BACE4",
                "&:hover": {
                  backgroundColor: "#1589b6",
                },
              }}
              onClick={onSubmit}
            >
              <>
                {isCommentCreating && <ClipLoader size={15} color="#fff" />}
                {!isCommentCreating && t("VALIDATE")}
              </>
            </Button>
          </ButtonWrapper>
        </div>
      </Dialog>
    </div>
  );
};

DiscussionList.propTypes = {
  t: PropTypes.func.isRequired,
  entityId: PropTypes.number,
  entityType: PropTypes.number,
};

DiscussionList.defaultProps = {
  entityId: null,
  entityType: "",
};
export default withTranslation()(DiscussionList);
